import "./styles.scss";
import { RedExclamationCircle } from "../../assets/svgs";
import CustomButton from "../CustomButton";
import { useTranslation } from "react-i18next";
import useApp from "../../hooks/useApp";
import contactLinks from "./contactLinks.json";

const CustomError = ({
  requestId,
  showPopup,
  handleTryAgain,
  title,
  message,
  hideRequestSection = false,
}) => {
  const { t } = useTranslation();
  const { tenantConfig } = useApp();

  const getTenantSlug = (url) => {
    try {
      const { hostname } = new URL(url);
      const parts = hostname.split(".");
      return parts.length > 1 ? parts[1] : null;
    } catch {
      return null;
    }
  };

  if (!showPopup) return null;

  const tenantSlug = tenantConfig?.slug
    ? tenantConfig?.slug
    : getTenantSlug(window.location.href);

  const contactUsLink = contactLinks[tenantSlug] || contactLinks.default;

  return (
    <div className="custom-error-container">
      <div className="error-image-wrapper">
        <img src={RedExclamationCircle} alt="error" className="error-image" />
      </div>
      <h2 className="error-title">
        {title ? t(title) : t("global.something_wrong")}
      </h2>
      <p className="error-description">
        {message ? t(message) : t("global.unexpected_error")}
      </p>

      {!hideRequestSection && (
        <>
          <p className="request-id-heading">{t("global.request_id_text")}</p>
          <p className="request-id-text">{requestId}</p>
          <CustomButton
            text={t("global.try_again")}
            style={{ maxWidth: "90%" }}
            onClick={handleTryAgain}
            buttonClassText={"button-text"}
          />
          <div className="link-text-container">
            <span className="label-text">{t("global.need_help")}</span>
            <a
              className="link-text"
              href={contactUsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("global.contact_us")}
            </a>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomError;
